import redirectHome from "./redirectHome";

const AUTH_KEY = "authorizationData";

const LocalStorageService = {
    set: (key, value, config = {}) => {
      localStorage.setItem(key, JSON.stringify(value));
    },
    clear: () => {
      localStorage.clear();
    },
    remove: (key) => {
      localStorage.removeItem(key);
    },
    get: (key, config = {}) => {
      let str = localStorage.getItem(key);
      if (!str) {
        return null;
      }
      try {
        return JSON.parse(str);
      } catch (error) {
        // Corrupt entry — e.g. authorizationData hand-edited in devtools and
        // left with a raw newline inside a JSON string. It can never be read
        // again, and throwing here takes down every caller (RolesHelper,
        // AppHeader, the axios interceptors). Drop it and report "not set".
        localStorage.removeItem(key);
        if (key === AUTH_KEY) {
          // An unreadable session is a dead session: tear it down exactly like
          // a failed refresh does, so the UI does not keep offering "Log Out".
          localStorage.removeItem("has_cashier_entered_desk_number");
          redirectHome();
        }
        return null;
      }
    },
    updateObject: (key, name, value) => {
      const stored = LocalStorageService.get(key);
      if (!stored) {
        LocalStorageService.set(key, { [name]: value });
        return;
      }
      LocalStorageService.set(key, {
        ...stored,
        [name]: value,
      });
    },
  };
  
  export default LocalStorageService;
  